/**
 * Global CTA / navigation safety: never emit dangerous or unusable targets.
 * Builds on resolveSmartLink; callers still run resolveInternalLink + getStorePath where needed.
 */

import { resolveSmartLink } from '@/lib/storefront/resolveSmartLink';

const DANGEROUS_PROTOCOL = /^\s*(javascript|data|vbscript):/i;

export function isDangerousHref(s: string): boolean {
  const t = s.trim();
  return DANGEROUS_PROTOCOL.test(t);
}

/**
 * Normalize any saved link shape to a single string safe for classification + routing.
 * - null / empty → "#"
 * - blocks javascript:, data:, vbscript:
 * - objects → resolveSmartLink
 */
export function resolveSafeLink(link: unknown): string {
  if (link == null || link === '') return '#';

  if (typeof link === 'object' && link !== null) {
    const s = resolveSmartLink(link).trim();
    if (!s || s === '#') return '#';
    if (isDangerousHref(s)) return '#';
    return s;
  }

  const raw = String(link).trim();
  if (!raw) return '#';
  if (isDangerousHref(raw)) return '#';

  const s = resolveSmartLink(raw).trim();
  if (!s) return '#';
  if (isDangerousHref(s)) return '#';
  return s;
}
